export default "__VITE_ASSET__4ea2e987__"